/**
 * Specifies a type of Security List.
 * tag: 1470
 * @readonly
 * @enum {number} (int)
 */
export enum SecurityListType {
  /** Industry Classification */
  IndustryClassification = 1,
  /** Trading List */
  TradingList = 2,
  /** Market / Market Segment List */
  Market = 3,
  /** Newspaper List */
  NewspaperList = 4,
}
